<app-home
  [headerMain]="'Developer Portal'"
  [headerSub]="'Empowering Experiences and Enabling Innovation: Your Development Starts Here'"
  [bodyHeader]="'Developer Tools'"
  [bodyContent]="'Your One-Stop solution for accessing the latest public APIs, mobile SDK documentation, and step-by-step integration guides.'"
></app-home>
